export default {
  title: 'Servis Yolcuları',
  assignments: 'Atamalar',
  associations: 'İlişkilendirmeler',
  assignRidersWithExcel: 'Excel ile Toplu Ata',
  rider: 'Yolcu',
  uniqueId: 'Sicil No',
  routeGroup: 'Rota Grubu',
  route: 'Rota',
  stop: 'Durak',
  distanceToStop: 'Durak Mesafesi',
  timeOnShuttle: 'Servis Süresi',
  assignmentsColumn: 'Atama',
  email: 'E-mail',
  company: 'Şirket',
  department: 'Departman',
  schedule: 'Çalışma Şekli',
  campus: 'Kampüs',
  noAssociation: 'İlişkilendirme Yok',
  notAssigned: 'Atanmadı',
  allCompanies: 'Tüm Şirketler',
  allDepartments: 'Tüm Departmanlar',
  allRouteGroups: 'Tüm Rota Grupları',
  allSchedules: 'Tüm Çalışma Durumları',
  variableShift: 'Değişken Vardiya',
  fixedShift: 'Sabit Vardiya',
  showOnlyStopsWithinWalkingDistance: 'Yalnızca yürüme mesafesindeki durakları göster',
  pendingRegularAssignmentBanner:
    'Düzenli çalışma saatine sahip yolcuların günlük tekrar eden rota kullanımını etkinleştirmek için ilişkilendirilmiş rotaları inceleyip yolcuları manuel olarak atamalısınız. Şu anda {0} {1} düzenli atama bekliyor.',
  showingPendingRegularAssignment: '{0} {1} düzenli atama bekliyor olarak gösteriliyor.',
  showAll: 'Tümünü göster',
  assign: 'Ata',
  assignSuccess: 'Yolcular başarıyla atandı.',
  assignToAssociatedGroups: 'İlişkili gruplara ata',
  sendForConfirmation: 'Onaya Gönder',
  addToGroup: 'Gruba Ekle',
  forAPeriod: 'Bir Dönem İçin',
  forRegularUse: 'Düzenli Kullanım İçin',
  startingFrom: 'Başlangıç',
  until: 'Bitiş',
  cancel: 'İptal',
  confirm: 'Onayla',
  deleteAssignment: 'Atamayı Sil',
  assignRegularConfirm:
    'Lütfen seçili yolcuları düzenli kullanım için ilgili rota gruplarına atamak istiyorsanız onaylayın.',
  addToGroupSuccess: '{0} personel seçilen rota grubuna başarıyla eklendi.',
  selectRouteGroup: 'Rota Grubu Seçin',
  riderSingular: 'yolcu',
  riderPlural: 'yolcu',
  assigned: 'Atandı',
  startDateRequired: 'Başlangıç tarihi zorunludur.',
  endDateRequired: 'Dönemli atama için bitiş tarihi zorunludur.',
  endDateBeforeStart: 'Bitiş tarihi başlangıç tarihinden önce olamaz.',
  startDateBeforeToday: 'Başlangıç tarihi bugünden önce olamaz.',
  assignmentsTabPlaceholder: 'Assignments sekmesi yakında eklenecek.',
  startDay: 'Başlangıç Tarihi',
  endDay: 'Bitiş Tarihi',
  ongoing: 'Devam Ediyor',
  deleteAssignmentConfirm: 'Seçili atamaları silmek istediğinizden emin misiniz?',
  deleteAssignmentSuccess: 'Atamalar başarıyla silindi.',
  noAssignments: 'Seçili dönem için atama bulunamadı.',
  noAssociations: 'Seçili kriterlere uygun ilişkilendirme bulunamadı.',
  assignPartialSkip: '{0} yolcu atandı. {1} yolcu, ilişkili rota veya durağı olmadığı için atlandı.',
  noAssociatedRoutesTitle: 'İlişkili Rota Bulunamadı',
  noAssociatedRoutesMessage:
    '{0} yolcu ilişkili rotalarına başarıyla atandı.<br><br>Ancak, {1} yolcu için ilişkili rota bulunamadığından atama yapılamadı. Uygun rota ve durak seçerek bu yolcuların atamalarını manuel olarak düzenlemeniz gerekiyor.',
  viewAssignmentsWithNoRoutes: 'Rotasız Atamaları Görüntüle',
  assignDisabledNoRoute:
    'Seçili yolcuların hiçbirinde atama için gerekli tüm bilgiler (rota grubu, rota, durak ve vardiya) bulunmuyor. Önce bir rota grubuna ekleyin veya ilişkilendirmeyi tamamlayın.',
};
